(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.property', [
    'ui.router',
    'pp.widgets-templates',
    'pp.services.auth',
    'pp.services.property',
    'pp.services.investor',
    'pp.services.route',
    'pp.services.config',
    'pp.services.preference',
    'pp.ui.services.restricted-investor-dialog',
    'pp.ui.services.auth-redirect',
    'pp.ui.services.classification-dialog',
    'pp.ui.services.risk-warning',
    'pp.widgets.property-status',
    'pp.widgets.property-carousel',
    'pp.widgets.property-image-single',
    'pp.widgets.document-links',
    'pp.widgets.expandable',
    'pp.widgets.floorplan',
    'pp.widgets.property-diagram',
    'pp.widgets.property-financials',
    'pp.widgets.property-notice-banner',
    'pp.widgets.map',
    'pp.widgets.property-details',
    'pp.widgets.property-events',
    'pp.widgets.property-social-sharing',
    'pp.widgets.funding-round-details',
    'pp.widgets.wistia-inline-video',
    'pp.ui.services.home-now-reit-disclaimer-dialog',
    'pp.ui.services.trust-disclaimer-dialog',
    'pp.ui.services.suitability-quiz-dialog',
    'pp.ui.services.investment-access-guard-dialog',
    'pp.values.trust'
]);

var PAGE_NAME = 'property';
var CAROUSEL_READY_TIMEOUT_MS = 1200;
var PROPERTY_STATE_PRE_ORDER = 'pre-order';
var PROPERTY_STATE_PRE_ORDER_CLOSED = 'pre-order-closed';

ngModule.component('ppProperty', {
    templateUrl: 'widgets/_angular/property/property.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ['$scope', '$q', '$timeout', '$state', '$anchorScroll', '$location', 'ppConfig', 'ppTrack', 'propertyService', 'investorService', 'routeService', 'authRedirect', 'restrictedInvestorDialog', 'classificationDialogService', 'riskWarningService', 'R', 'configService', 'preferenceService', 'homeNowReitDisclaimerDialog', 'trustDisclaimerDialog', 'suitabilityQuizDialog', 'trustDescriptions', 'investmentAccessGuardDialogService', function ($scope, $q, $timeout, $state, $anchorScroll, $location, ppConfig, ppTrack, propertyService, investorService, routeService, authRedirect, restrictedInvestorDialog, classificationDialogService, riskWarningService, R, configService, preferenceService, homeNowReitDisclaimerDialog, trustDisclaimerDialog, suitabilityQuizDialog, trustDescriptions, investmentAccessGuardDialogService) {
        var vm = this;

        // -- initial state

        var __config = ppConfig.get('pp.widgets.property') || {};
        var symbol = __config.property ? __config.property.symbol : null;

        var googleMaps = window.pp.googleMaps;
        var googlemapsApiKey = (window.pp.config.get('googlemaps.api') || {}).key;
        var params = new window.URLSearchParams(window.location.search);
        var ref = params.get('ref');

        vm.trust = trustDescriptions;

        var financialTabs = {
            unitsDisclosure: 'individual-unit-details',
            forecastIncome: 'rental-income-breakdown',
            shareValuation: 'share-valuation'
        };

        vm.exitMechanicHelp = routeService.exitMechanicHelp;
        vm.imHomeNow = routeService.imHomeNow;
        vm.kidHomeNow = routeService.kidHomeNow;

        // anonymous users are sent to the login or signup page rather than the auth modal,
        // and return to this property page once they have authenticated
        function requireInvestor() {
            return authRedirect.requireInvestor(authRedirect.getCurrentPath(), PAGE_NAME + '.auth-redirect');
        }

        function redirectBlockedUser() {
            ppTrack.pageEvent(PAGE_NAME, 'requiredPermissions');
            window.location.href = routeService.marketplacePath;
        }

        function handleImagesSuccess(images) {
            vm.numberOfImages = images.numberOfImages;
            vm.carouselLoaded = true;
            $timeout(function () {
                vm.carouselReady = true;
            }, CAROUSEL_READY_TIMEOUT_MS).then(function () {
                $timeout(function () {
                    vm.hideCarouselLoading = true;
                }, 300);

            });
        }

        function handleImagesError() {
            vm.numberOfImages = 0;
            vm.carouselReady = true;
            vm.carouselLoaded = true;
        }

        function handleNonMainstreamLoad(user, property, forceLogin) {
            var localUser;

            if (property.isFund && !forceLogin) {
                return $q.when();
            }

            return requireInvestor()
                .then(function (user) {
                    localUser = user;
                    return classificationDialogService.classifyUser(user, angular.noop);
                })
                .then(restrictedInvestorDialog.reclassifyUserForRestrictedInvestment)
                .then(function () {
                    if (property.isTrust) {
                        return investorService.escapeFromIsa(localUser).then(function () {
                                return preferenceService.hasAgreedToTrustDisclaimer();
                            })
                            .then(function (hasAgreed) {
                                if (!hasAgreed) {
                                    return $timeout(function () {
                                        return trustDisclaimerDialog.showDialog(user, property);
                                    }, 100);
                                }
                            }).then(function () {
                                return $timeout(function () {
                                    return suitabilityQuizDialog.showForPassAnyQuizzes(['trust_1', 'trust_2'], false, localUser.classification);
                                }, 100);
                            });
                    }
                });
        }

        function handleLoad(res) {
            if (res.property.isBlockedForRetail) {
                handleNonMainstreamLoad(res.investor, res.property, !ref)
                    .then(function () {
                        return investmentAccessGuardDialogService.checkAccess(res.property);
                    })
                    .then(function () {
                        return investmentAccessGuardDialogService.checkShariaAccess(res.property);
                    })
                    .then(function () {
                        vm.ready = true;

                        $timeout(function () {
                            if ($state.current.name === 'property-key-risks') {
                                $location.hash('pp-property-key-risks-section');
                                $timeout(function () {
                                    $anchorScroll.yOffset = 100;
                                    $anchorScroll();
                                });
                            }

                        });
                    }, redirectBlockedUser);
            } else {
                requireInvestor()
                    .then(function (user) {
                        return classificationDialogService.kycAndClassifyUser(user, angular.noop);
                    })
                    .then(function () {
                        return investmentAccessGuardDialogService.checkAccess(res.property);
                    })
                    .then(function () {
                        return investmentAccessGuardDialogService.checkShariaAccess(res.property);
                    })
                    .then(function () {
                        vm.ready = true;
                    }).catch(redirectBlockedUser);

            }

            if (res.property.isDevelopmentLoan && !res.property.notMiniBond) {
                riskWarningService.showDevLoanRiskWarning();
            }

            if (res.property.isFundingRound) {
                riskWarningService.showFundRaisingRiskWarning();
            }
        }

        function handleInvestorSuccess(user) {
            vm.user = user;
            return user;
        }

        function handleIncomeDisclosureSuccess(data) {
            vm.incomeDisclosure = data;
            return data;
        }

        function handleUnitsDisclosureSuccess(data) {
            vm.unitsDisclosure = R.head(data);
            return data;
        }

        var SEPARATOR = '<p><b>---</b></p>';

        var extractFinPromBlob = R.compose(
            function (htmls) {
                if (R.isEmpty(htmls)) {
                    return '';
                }

                return R.join(SEPARATOR, htmls) + SEPARATOR;
            },
            R.map(R.prop('html')),
            R.defaultTo([])
        );

        function handleFinPromDisclosureSuccess(property) {
            return function (data) {
                var baseFinProm = R.defaultTo('', R.path(['media', 'investmentCaseDescription'], property));
                var extraFinProms = extractFinPromBlob(data);
                vm.finPromDisclosure = R.concat(extraFinProms, baseFinProm);
                return data;
            };
        }

        function handlePropertySuccess(data) {
            vm.property = data;

            if (vm.property.state.status === PROPERTY_STATE_PRE_ORDER || vm.property.state.status === PROPERTY_STATE_PRE_ORDER_CLOSED) {
                ppTrack.setContext('offer.preorder', true);
            }

            ppTrack.pageLoad(PAGE_NAME);

            // -- map
            vm.type = PAGE_NAME;
            vm.loc = [{
                latitude: vm.property.location.geo.latitude,
                longitude: vm.property.location.geo.longitude
            }];

            var disclosurePropertySymbol = vm.property.parentPropertySymbol || vm.property.symbol;

            var disclosurePromises = $q.all({
                disclosure: propertyService.getPropertyIncomeDisclosure(disclosurePropertySymbol).then(handleIncomeDisclosureSuccess, function () {
                    vm.incomeDisclosure = [];
                }),
                unitDisclosure: propertyService.getPropertyUnitsDisclosure(disclosurePropertySymbol).then(handleUnitsDisclosureSuccess, function () {
                    vm.unitsDisclosure = [];
                }),
                finPromDisclosure: propertyService.getPropertyFinPromDisclosure(disclosurePropertySymbol).then(handleFinPromDisclosureSuccess(vm.property), function () {
                    vm.unitsDisclosure = [];
                }),
            });

            return disclosurePromises.then(function () {
                return data;
            }, function () {
                return data;
            });
        }

        function handleUnitValuationDateSuccess(data) {
            vm.unitValuationDate = data;
            return data;
        }

        // -- api

        vm.handleNonMainstreamLoad = function (user, property) {
            vm.ready = false;

            return handleNonMainstreamLoad(user, property, true).then(function () {
                return investorService.getInvestor().then(handleInvestorSuccess);
            }).then(function () {
                vm.ready = true;
            }, function () {
                redirectBlockedUser();
            });
        };

        vm.tabChange = function (tab) {
            var newPath = financialTabs[tab];
            if (newPath) {
                $state.go('property.' + tab, null, {
                    location: 'replace'
                });
            }
        };

        // -- scope bindings

        // -- main

        propertyService.getImages(symbol).then(handleImagesSuccess, handleImagesError);

        var promises = {
            investor: investorService.getInvestor().then(handleInvestorSuccess),
            property: propertyService.getPropertyData(symbol).then(handlePropertySuccess),
            unitValuationDate: configService.getUnitValuationDate().then(handleUnitValuationDateSuccess, function () {})
        };

        $q.all(promises).then(handleLoad);

    }]
});
})(window, window.angular);